import { Role } from '../../../../shared/enums/role.enum';
import { SecondarySideMenuI } from '../../../../shared/interfaces/secondary-side-menu.interface';

export const SIDE_MENU_ITEMS: SecondarySideMenuI[] = [
  {
    translationPath: 'sideMenu.national',
    activeIcon: 'svgs/side-menu/active-course.svg',
    nonActiveIcon: 'svgs/side-menu/non-active-course.svg',
    route: () => 'national',
    alt: 'national',
    roles: [Role.SUPER_ADMIN, Role.ADMIN, Role.DEAN, Role.PROGRAM_MANAGER],
  },
  {
    translationPath: 'sideMenu.client',
    activeIcon: 'svgs/side-menu/active-student.svg',
    nonActiveIcon: 'svgs/side-menu/non-active-student.svg',
    route: () => 'client',
    alt: 'Client',
    roles: [Role.SUPER_ADMIN, Role.ADMIN, Role.DEAN, Role.PROGRAM_MANAGER],
  },
];
